<template>
  <div>
    <v-modal-contents ref="modal_contents_agree">

      <template v-slot:close>
        <!--        убираем close-->
        <div></div>
      </template>

      <template v-slot:title>

        <div class="terms_of_use__title">
          <div class="h2_title">Условия использования персональных данных</div>

        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <div v-html="terms"></div>
          <div class="mt-30">
            <button class="px-30 btn_bordered "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>

          </div>
        </div>
      </template>
    </v-modal-contents>
    <v-form ref="form" class="formNew_wrap" v-model="valid" lazy-validation>

      <div class="row mx-0 my-0">
        <slot name="description">
          <div class="col-12 col-md-6 col-lg-6 p-md-2">
          </div>
        </slot>
        <div class="col-12 col-md-6 col-lg">
          <div class="row">
            <div class="col-12 col-md-12 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">

                <v-text-field
                    v-model="name"
                    :rules="[rules.required, rules.ruleTownName]"
                    required=""
                    class="form__input"
                    id="name"
                >

                  <template v-slot:label>
                    ФИО *
                  </template>
                </v-text-field>


              </div>
            </div>

            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item item_tel position-relative">
                <!--            this.value = this.value.replace(/^8/, '');-->
                <!--            oninput="this.value = this.value.replace(/[^\d]/g,''); this.value = this.value.slice(0,10);this.value = this.value.replace(/^\(?8\)?/, '')"-->
                <v-text-field
                    v-model="tel_input"
                    :rules="tel_inputRulesRu"
                    required
                    id="tel"
                    oninput="this.value = this.value.replace(/^\(8/, '(');"
                    class="pl-0 form__input"
                    max="20"
                    v-mask="'# ### ###-##-##'"

                >

                  <template v-slot:label>
                    Телефон *
                  </template>
                </v-text-field>

                <!--            <v-select-->
                <!--                :items="tel_items"-->
                <!--                :menu-props="{ contentClass: 'wrapp_selCoop' }"-->
                <!--                item-value="sel_id"-->
                <!--                v-model="defaultSelectedTel.sel_id"-->
                <!--                solo-->
                <!--                class="tel_sel__btn d-flex align-items-center"-->
                <!--                append-icon="mdi mdi-chevron-down"-->
                <!--            >-->
                <!--              <template slot="selection" slot-scope="data">-->
                <!--                <img :src="data.item.icon"></img>-->
                <!--                <span class="tel_kod">{{ data.item.kod }}</span>-->
                <!--              </template>-->

                <!--              <template slot="item" slot-scope="data">-->
                <!--                <img class="pr-2" :src="data.item.icon"></img>-->
                <!--                <span>{{ data.item.name }}</span>-->
                <!--              </template>-->
                <!--            </v-select>-->
                <!--            <v-text-field v-if="language == 'ru'"-->
                <!--                          v-model="tel_input"-->
                <!--                          :rules="tel_inputRulesRu"-->
                <!--                          required-->
                <!--                          placeholder="Телефон"-->
                <!--                          id="tel"-->
                <!--                          oninput="this.value = this.value.replace(/[^\d]/g,'');"-->
                <!--                          class="tel_input form__input"-->
                <!--            >-->


                <!--            </v-text-field>-->

                <!--            <v-select-->
                <!--                :items="tel_items"-->
                <!--                :menu-props="{ contentClass: 'wrapp_selCoop' }"-->
                <!--                item-value="sel_id"-->
                <!--                v-model="defaultSelectedTel.sel_id"-->
                <!--                solo-->
                <!--                class="tel_sel__btn d-flex align-items-center"-->
                <!--                append-icon="mdi mdi-chevron-down"-->
                <!--            >-->
                <!--              <template slot="selection" slot-scope="data">-->
                <!--                <img :csrc="data.item.icon"></img>-->
                <!--                <span class="tel_kod">{{ data.item.kod }}</span>-->
                <!--              </template>-->

                <!--              <template v-if="language == 'ru'" slot="item" slot-scope="data">-->
                <!--                <img class="pr-2" :src="data.item.icon"></img>-->
                <!--                <span>{{ data.item.name }}</span>-->
                <!--              </template>-->

                <!--            </v-select>-->

              </div>
            </div>
            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">
                <v-text-field class="form__input" v-if="language == 'ru'"
                              v-model="email"
                              :rules="[rules.mail]"
                              required
                              oninput="this.value = this.value.trim()"
                              id="email"
                >
                  <template v-slot:label>
                    Электронная почта *
                  </template>
                </v-text-field>

              </div>
            </div>

            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">
                <!--            :rules="[rules.required, rules.ruleTownName]"-->
                <!--            required-->
                <v-text-field
                    v-model="сountry"

                    :rules="[rules.required]"
                    required
                    class="form__input"
                    id="company"

                >
                  <template v-slot:label>
                    Страна *
                  </template>
                </v-text-field>
              </div>
            </div>

            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">
                <!--            :rules="[rules.required, rules.ruleTownName]"-->
                <!--            required-->
                <v-text-field
                    v-model="city"

                    :rules="[rules.required]"
                    required
                    class="form__input"
                    id="company"

                >
                  <template v-slot:label>
                    Город *
                  </template>
                </v-text-field>
              </div>
            </div>

            <!--            <div class="col-12 col-md-12 pb-3 px-3 pt-3">-->
            <!--              <div class="formNew_wrap__item">-->
            <!--                &lt;!&ndash;            :rules="[rules.required, rules.ruleTownName]"&ndash;&gt;-->
            <!--                &lt;!&ndash;            required&ndash;&gt;-->
            <!--                <v-textarea-->
            <!--                    v-model="message"-->
            <!--                    rows="3"-->
            <!--                    class="form__input"-->
            <!--                    id="comment"-->

            <!--                >-->
            <!--                  <template v-slot:label>-->
            <!--                    Комментарий-->
            <!--                  </template>-->
            <!--                </v-textarea>-->
            <!--              </div>-->
            <!--            </div>-->

            <div class="col-12 col-md-12 px-3 pt-3">
              <div class="form_upload__item ">
                <div
                    class="summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center"
                    @dragover="dragover"
                    @dragleave="dragleave"
                    @drop="drop"
                    id="summary"
                >
                  <input
                      type="file"
                      multiple
                      name="fields[assetsFieldHandle][]"
                      id="assetsFieldHandle"
                      class="w-px h-px opacity-0 overflow-hidden absolute"
                      @change="onChange"
                      ref="file"
                      accept=".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx"
                  />

                  <label for="assetsFieldHandle" class="block cursor-pointer">
                    <div>Выберите или перетащите сюда файл в формате PDF, DOC, DOCX,
                      RTF, JPG
                    </div>
                  </label>
                  <ul class="mt-4" v-if="this.filelist.length" v-cloak>
                    <li class="text-sm p-1 text-left" v-for="(file, index) in filelist"
                        :key="index">
                      {{ file.name }}
                      <button
                          class="ml-2 remove_file"
                          type="button"
                          @click="remove(filelist.indexOf(file))"
                          title="Remove file">
                        Удалить
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-12 pb-3 px-3 pt-3">
              <!-- SmartCaptcha -->
              <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                   class="w-100 mt-30"></div>
              <div class="formNew_wrap__item  mt-30">
                <v-checkbox
                    v-model="checkbox"
                    :rules="[(v) => !!v || 'Это обязательный пункт']"
                    required
                    color="red"
                >
                  <template v-slot:label>
                    <div class="customLabelForm">
                      Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                              @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                      использования</a> моих персональных данных для обработки данного обращения
                      ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область,
                      г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю
                      согласие с
                      <a :href="policy" @click="linkOpen(policy)" class="position-relative zi-1">Политикой
                        конфиденциальности</a> и <a :href="agreement"
                                                    @click="linkOpen(agreement)"
                                                    class="position-relative zi-1">Пользовательским
                      соглашением.</a>
                    </div>
                  </template>
                </v-checkbox>

                <!--            :rules="[(v) => !!v || 'Это обязательный пункт']"-->
                <!--            required-->
                <v-checkbox
                    v-model="consentToInform"

                    color="red"
                    class="mt-0"
                >
                  <template v-slot:label>
                    <div class="customLabelForm">
                      Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                      предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес:
                      141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,
                      этаж 2) и
                      партнеров.
                    </div>
                  </template>
                </v-checkbox>

                <div class="btn_form d-flex align-items-center  ">
                  <v-btn :disabled="!valid" class="btn-red w-mc"
                         @click="sendForm">
                    Отправить
                  </v-btn>

                  <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->

                  <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
                </div>
              </div>

            </div>

          </div>
        </div>


      </div>

    </v-form>
  </div>

</template>
<script>
import VModalContents from "./modal_contents";
import {mask} from 'vue-the-mask';

export default {
  components: {
    VModalContents: VModalContents,
  },
  directives: {mask},
  name: "formNew",
  props: {
    // lang: Array | String | Number | Boolean | Object,
    directions: Array | String | Number | Boolean | Object,
    policy: String | Boolean,
    agreement: String | Boolean,
    terms: String | Boolean,
  },
  delimiters: ["${", "}"], // Avoid Twig conflicts
  data() {
    return {
      captchaPassed: false,

      valid: true,

      language: "ru",
      rules: {
        required: value => !!value || 'Обязательное поле',
        ruleOrg: value => {
          const patternOn = /[~`@#$%^*={}\[\];:<>.,\/\\-_]/g
          return !patternOn.test(value) || 'Неккоректный ввод'
        },

        ruleProd: value => {
          const patternPd = /[~`@#$%^*={}\[\];:<>.,\/\\-_]/g
          return !patternPd.test(value) || 'Неккоректный ввод'
        },

        ruleTownName: value => {
          const patternSp = /[~`!@№#$%^&*()+={}\[\];:\'\"<>.,]|[0-9_]/g
          return !patternSp.test(value) || 'Неккоректный ввод'
        },

        mail: value => {
          const pattern = /^(([^<>()[\]\\{\/№%^!#/$?*~+=.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Неккоректная электронная почта'
        },

        phone: value => {
          const pattern = /^\+?[1-9][0-9]{7,14}$/
          return pattern.test(value) || 'Некорректный телефон'
        }
      },
      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 3) || "Name must be less than 10 characters",
      ],

      nameRulesRu: [
        (v) => !!v || "Обязательное поле",
        (v) => (v && v.length >= 3) || "Поле 'ФИО' не может быть меньше 3 символов",
      ],

      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      emailRulesRu: [
        (v) => !!v || "Обязательное поле",
        (v) => /.+@.+\..+/.test(v) || "E-mail заполнен неправильно",
      ],

      select_directionСoop: null,
      //directionСoopRu: ["Логистические услуги – склад, город, РФ", "Логистические услуги – ВЭД", "Закупка сырья и материалов", "Закупка оборудования и запчастей", "Другие направления"],
      directionСoopRu: this.directions,

      /*directionСoopRu: [
        { name: "test", id: "123" },
        { name: "test1", id: "321" }
      ],*/
      //   directionСoop: ["Russia", "Poland", "Kazakhstan"],


      comment: "",

      сountry: "",
      city: "",
      // message: "",
      /*companyRules: [
          (v) => !!v || "Company is required",
          (v) => (v && v.length >= 3) || "Company name must be more then 3 characters",
      ],
      companyRulesRu: [
          (v) => !!v || "Поле 'Компания' не может быть пустым",
          (v) => (v && v.length >= 3) || "Поле 'Компания' не может быть меньше 3 символов",
      ],*/

      tel_select: null,
      tel_items: [
        {
          sel_id: 0,
          name: "Россия",
          eng_name: "Russia",
          icon: "/local/templates/international/img/FlagRossii.svg",
          kod: "+7",
        },
        // {
        //   sel_id: 1,
        //   name: "Польша",
        //   eng_name: "Poland",
        //   icon: "/local/templates/international/img/FlagPaulshi.svg",
        //   kod: "+2",
        // },
        {
          sel_id: 1,
          name: "Казахстан",
          icon: "/local/templates/international/img/FlagKazakhstana.svg",
          kod: "+7",
        },
      ],

      defaultSelectedTel: {
        sel_id: 0,
      },

      tel_input: "",

      tel_inputRulesRu: [
        (v) => !!v || "Обязательное поле",
        // (v) => /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(v) || "Поле 'Телефон' заполнено неправильно",
      ],

      checkbox: false,
      consentToInform: false,
      // upload drag-and-drop file
      filelist: [],

    };
  },

  methods: {

    linkOpen(url) {
      window.open(url, '_blank');
    },
    // Captcha
    initCaptcha() {
      window.smartCaptcha.render('captcha-container', {
        sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
        callback: this.onCaptchaSuccess,
      });
    },
    onCaptchaSuccess(token) {
      this.captchaPassed = true;
      this.form.captchaToken = token;
    },
    // Captcha end
    sendForm() {
      if (!this.$refs.form.validate()) return false;
      // if (!this.captchaPassed) {
      //     this.valid = false;
      //     return false;
      // } else {
      //     this.valid = true;
      // }
      /** AJAX */
      var VueObject = this;
      var formData = new FormData();
      $.each(VueObject.filelist, function (key, value) {
        formData.append(key, value);
      });

      let newTel = VueObject.tel_input;
      if (newTel[0] === '7') {
        newTel = "+ " + newTel; // если первая цифра 7, добавляем +
      }
      console.log(newTel);

      //formData.append("direction", VueObject.directionСoopRu[VueObject.select_directionСoop]);
      formData.append("name", VueObject.name);
      formData.append("phone", newTel);
      formData.append("email", VueObject.email);
      formData.append("сountry", VueObject.сountry);
      formData.append("city", VueObject.city);
      formData.append("ajaxPost", "Y");
      console.log(formData);
      $.ajax({
        "type": "POST",
        "url": "/ajax/career_form.php",
        "data": formData,
        "cache": false,
        "dataType": 'json',
        "processData": false, // Не обрабатываем файлы (Don't process the files)
        "contentType": false, // Так jQuery скажет серверу, что это строковой запрос
        "success": function (res) {
          console.log(res);
          $(".text_result").slideDown(300);
          $(".text_result").delay(3000).slideUp(300);
          VueObject.$refs.form.reset();
          setTimeout(function () {
            window.location.reload()
          }, 3000);
        },
        "error": function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.status);
          console.log(thrownError);
        },
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    // upload drag-and-drop file

    onChange() {
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },

    // upload drag-and-drop file end
  },
  created() {
    setTimeout(() => {
      this.initCaptcha();
    }, 500)
  },
  watch: {
    captchaPassed() {
      // this.sendForm();
      if (!this.captchaPassed) {
        this.valid = false;
        return false;
      } else {
        this.valid = true;
      }
    },
  }
};
</script>

<style lang="scss">
@import "../../theme/_variable.scss";

.wrapp_formNew.v-menu__content {
  margin-top: 51px;

}

.formNew {
  @media(max-width: 576px) {
    margin-top: 10px;
  }

  .smart-captcha {
    min-width: 220px;
  }

  .smart-captcha.error-captcha:before {
    background: transparent;
  }

  .v-text-field .v-label {
    background: #ffffff;
    height: 22px;
    width: 100%;
    color: #404040;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: unset;
  }

  h2.formNew_h2 {
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-style: 500;
    font-size: 52px;
    leading-trim: NONE;
    line-height: 68px;
    letter-spacing: -1.04px;
    vertical-align: middle;

  }

  .formNew_p {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0px;
    color: #212424;
    margin: 0;

    @media (max-width: 650px) {
      font-size: 24px !important;
      line-height: 30px !important;
    }

    @media (max-width: 500px) {
      font-size: 20px !important;
      line-height: 24px !important;
    }
  }

  .formNew_link {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-size: 52px;
    line-height: 68px;
    letter-spacing: -1.04px;
    color: #212424 !important;

    @media (max-width: 768px) {
      font-size: 40px !important;;
      line-height: 46px !important;;
    }

    @media (max-width: 650px) {
      font-size: 40px !important;;
      line-height: 46px !important;;
    }

    @media (max-width: 500px) {
      font-size: 30px !important;
      line-height: 36px !important;
      margin-bottom: 20px !important;
    }
  }

  .formNew__list {
    //position: relative;
    //display: flex;
    //flex-wrap: wrap;
    //padding-left: 30px;

    svg {
      //position: absolute;
      //top: 0;
      //left: 0;
      width: 20px;
      min-width: 20px;
      margin-top: 4px;
    }
  }

  & .formNew_wrap__item .primary--text {
    color: #656565 !important;
    caret-color: #656565 !important;
  }

  ul li,
  & p {
    color: rgb(40, 40, 40);
    font-size: 20px;
    font-family: "RobotoRegular";
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
    @media(max-width: 768px) {
      font-size: 18px;
    }
    @media(max-width: 576px) {
      font-size: 16px;
    }
  }

  & .formNew_wrap .theme--light.v-btn.v-btn--has-bg[disabled="disabled"] {
    background: radial-gradient(50% 50% at 50% 50%, rgb(176 176 176 / 80%) 0%, #c1b8b8 100%) !important;

    & .v-btn__content {
      color: white;
    }
  }

  & .formNew_wrap__item ul {
    list-style: none;
    margin-left: 22px;
  }

  & .v-text-field__details {
    position: absolute;
    display: flex;
    transform: translate(-1px, 38px);
  }

  & .v-label--active {
    //top: 15px !important;
  }

  & form.formNew_wrap {
    box-sizing: border-box;
    border: 1px solid rgb(242, 242, 242);
    border-radius: 30px;
    background: #F5F5F7;
    padding: 20px 20px;
  }

  & .formNew_wrap .tel_sel__btn {
    width: max-content;
    height: 0;
    position: absolute;
    top: 32px;
    background: none;
    margin-left: 15px !important;
  }

  & .form__input {
    width: auto;
    border: 1px solid #F0F0F0;
    border-radius: 6px;
    padding: 25px 15px !important;
    margin: 0 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #282828;
    resize: none;
    background: #FFFFFF;
  }

  & .v-input__slot {
    margin: 0 !important;

    &::before {
      display: none !important;
    }

    &::after {
      display: none !important;
    }
  }

  // upload drag-and-drop file
  & .form_upload__item .remove_file {
    color: red;
  }

  .drag_form {
    background: rgba(249, 66, 55, 0.06);
    border: 1px dashed #f94237 !important;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "RobotoRegular";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    display: flex;
    align-items: center;
    color: #000000;
    opacity: 0.7;
    text-align: center;
  }

  & .form_upload__item .summary label {
    font-family: "RobotoRegular";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    align-items: center;
    color: #FA4237;
    opacity: 0.7;
    width: 100%;
    margin: auto;
    height: 100%;
    padding: 40px 21px;
    justify-content: center;
  }

  & .form_upload__item .primary--text {
    color: #656565 !important;
    caret-color: #656565 !important;
  }

  & .form_upload .theme--light.v-btn.v-btn--has-bg[disabled="disabled"] {
    background: radial-gradient(50% 50% at 50% 50%, rgb(176 176 176 / 80%) 0%, #c1b8b8 100%) !important;

    & .v-btn__content {
      color: white;
    }
  }

  & .form_upload__item ul {
    list-style: none;
    margin-left: 22px;
  }

  & .form_upload__item label {

    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #656565;
  }

  & form.form_upload {
    box-sizing: border-box;
    border: 1px solid rgb(242, 242, 242);
    border-radius: 30px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
    background: rgb(255, 255, 255);
    padding: 20px 20px;
  }

  & .form_upload .tel_sel__btn {
    width: max-content;
    height: 0;
    position: absolute;
    top: 32px;
    background: none;
    margin-left: 15px !important;
  }

  .drag_form {
    background: rgba(249, 66, 55, 0.06);
    border: 1px dashed #f94237 !important;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "RobotoRegular";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    display: flex;
    align-items: center;
    color: #000000;
    opacity: 0.7;
    text-align: center;
  }

  // upload drag-and-drop file
}

.v-input.tel_input.form__input.v-input--is-focused .v-label,
.v-input.tel_input.form__input.v-input--is-label-active .v-label--active {
  display: none;
}

.v-list-item {
  @media (max-width: 766px) {
    margin-bottom: 10px;
  }
}
</style>